export default __webpack_public_path__ + "static/media/showcase-hero-thumb.2e37394a.png";